"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messageScenario = exports.MessageScenario = void 0;
var MessageScenario;
(function (MessageScenario) {
    MessageScenario["ADDRESS_VALIDATION_ERROR"] = "ADDRESS_VALIDATION_ERROR";
    MessageScenario["CRM_FAIL"] = "CRM_FAIL";
    MessageScenario["CRM_SUCCESS"] = "CRM_SUCCESS";
    MessageScenario["FEEDBACK_CONTENT"] = "FEEDBACK_CONTENT";
})(MessageScenario || (exports.MessageScenario = MessageScenario = {}));
exports.messageScenario = [
    {
        label: 'Address Validation Error',
        value: MessageScenario.ADDRESS_VALIDATION_ERROR
    },
    {
        label: 'CRM Request Failure',
        value: MessageScenario.CRM_FAIL
    },
    {
        label: 'CRM Request Success',
        value: MessageScenario.CRM_SUCCESS
    },
    {
        label: 'Feedback Content',
        value: MessageScenario.FEEDBACK_CONTENT
    }
];
